module.exports = __webpack_public_path__ + "media/images/progress_mask3-08c45ca6.svg";